export const tashkilRegx =
  /[\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\u06d4-\u06df\u06e0-\u06ed]/g;
export const punctuation = /[()؛؟.!،:1234567890-]/g;
export const punctuationWithoutNumbers = /[()؛؟.!،:-]/g;
export const whitespaces = /  +/g;
